import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Locations from './Locations';

const MemberLocationsCard = () => (
  <Box sx={{ marginTop: 5 }}>
    <Card sx={{ borderRadius: 2, boxShadow: 2, padding: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ marginBottom: 2 }}>
          Member Locations
        </Typography>
        <Box sx={{ height: 400 }}>
          <Locations />
        </Box>
      </CardContent>
    </Card>
  </Box>
);

export default MemberLocationsCard;
